import { zones } from "@/mocks/homeContent";

const counts = ["12 份", "08 条", "21 场", "34 组", "09 条", "16 场"];

export default function Zones() {
  return (
    <section id="zones" className="w-full bg-background-100">
      <div className="container-x py-12 md:py-16">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-800">
            <i className="ri-archive-stack-line" />
            分区整理 · 起底档案
          </p>
          <h2 className="font-heading mt-3 text-2xl font-black md:text-4xl">按工作流归类的起底档案</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-500">
            从线索入库到结论复盘，六大分区对应深挖的一整条链路。想从哪一环切入，点进对应分区即可。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {zones.map((z, i) => (
            <a
              key={z.name}
              href="#dig"
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${z.icon} text-xl`} />
                </span>
                <span className="text-xs font-semibold text-foreground-300">{counts[i]}</span>
              </div>
              <h3 className="font-heading mt-4 text-lg font-black text-foreground-950">{z.name}</h3>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{z.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="text-[11px] text-foreground-400">本期新增 {1 + (i % 3)} 份</span>
                <span className="inline-flex items-center gap-1 text-xs font-bold text-primary-600">
                  进入分区
                  <i className="ri-arrow-right-up-line" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}